import { Currency } from './invoice';

export enum ExpenseStatus {
  NEW = 'NEW',
  APPROVED = 'APPROVED',
  PAID = 'PAID',
  CANCELLED = 'CANCELLED'
}

export interface Expense {
  id: string;
  companyId: string;
  counterpartyId: string;
  counterpartyName: string;
  documentNumber: string;
  title?: string;
  issueDate: string;
  dueDate?: string;
  paymentDate?: string;
  currency: Currency;
  netAmount?: number;
  taxAmount?: number;
  grossAmount?: number;
  category?: string;
  notes?: string;
  status: ExpenseStatus;
  fileName?: string;
  originalFileName?: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateExpenseRequest {
  counterpartyId: string;
  documentNumber: string;
  title?: string;
  issueDate: string;
  dueDate?: string;
  paymentDate?: string;
  currency: Currency;
  netAmount?: number;
  taxAmount?: number;
  grossAmount?: number;
  category?: string;
  notes?: string;
  status?: ExpenseStatus;
}

export interface UpdateExpenseRequest extends CreateExpenseRequest {}

